import { render, staticRenderFns } from "./afiliacionGrupal.vue?vue&type=template&id=cef10222&"
import script from "./afiliacionGrupal.vue?vue&type=script&lang=js&"
export * from "./afiliacionGrupal.vue?vue&type=script&lang=js&"
import style0 from "./afiliacionGrupal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports